import { NgModule } from '@angular/core';

import { ConnectionTypesSharedModule } from 'app/connection-types/connection-types-shared.module';
import { NoteModule } from 'app/note/note.module';
import { SharedModule } from 'shared/shared.module';

import {
  AdvancedResponseSelectorComponent
} from './components/advanced-response-selector/advanced-response-selector.component';
import {
  AppliedTagCategoryTableComponent
} from './components/applied-tag-category-table/applied-tag-category-table.component';
import {
  AppliedTagGroupTableComponent
} from './components/applied-tag-group-table/applied-tag-group-table.component';
import { AppliedTagRowComponent } from './components/applied-tag-row/applied-tag-row.component';
import { ApplyTagComponent } from './components/apply-tag/apply-tag.component';
import {
  FieldResponseQuickSearchComponent
} from './components/field-response-quicksearch/field-response-quicksearch.component';
import {
  FieldSearchInlineComponent
} from './components/field-search-inline/field-search-inline.component';
import {
  FieldSearchSelectComponent
} from './components/field-search-select/field-search-select.component';
import {
  ResponseItemTmplDirective
} from './components/response-search/response-item-templ.directive';
import {
  ResponseNoResultsTmplDirective, ResponseSearchComponent
} from './components/response-search/response-search.component';
import { ShiftDayLineComponent } from './components/shift-response-view/shift-day-line.component';
import {
  ShiftResponseViewComponent
} from './components/shift-response-view/shift-response-view.component';
import {
  TagListItemLabelComponent
} from './components/tag-list-item/tag-list-item-label.component';
import { TagListItemComponent } from './components/tag-list-item/tag-list-item.component';
import {
  AddOrUpdateFieldResponseDialog
} from './dialogs/add-or-update-field-response/add-or-update-field-response.dialog';
import {
  ApplyTagWithFieldSelectDialog
} from './dialogs/apply-tag-with-field-select/apply-tag-with-field-select.dialog';
import { ApplyTagDialog } from './dialogs/apply-tag/apply-tag.dialog';
import { CampaignsForFieldDialog } from './dialogs/campaigns-for-field.dialog';
import { CampaignsForResponseDialog } from './dialogs/campaigns-for-response.dialog';
import { ShiftAddOrUpdateDialog } from './dialogs/shift-add-or-update/shift-add-or-update.dialog';
import { ApplyTagFormComponent } from './forms/apply-tag-form/apply-tag-form.component';
import {
  ApplyTagMultiFormComponent
} from './forms/apply-tag-multi-form/apply-tag-multi-form.component';
import { FieldResponseFormComponent } from './forms/field-response/field-response-form.component';
import { ShiftInfoFormComponent } from './forms/shift-info-form/shift-info-form.component';

const DIRECTIVES = [
  ResponseItemTmplDirective,
  ResponseNoResultsTmplDirective
];

const COMPONENTS = [
  AppliedTagCategoryTableComponent,
  AppliedTagGroupTableComponent,
  AppliedTagRowComponent,
  TagListItemLabelComponent,
  ResponseSearchComponent,
  FieldResponseQuickSearchComponent,
  FieldSearchSelectComponent,
  FieldSearchInlineComponent,
  AdvancedResponseSelectorComponent,
  ShiftResponseViewComponent,
  ShiftDayLineComponent,
  TagListItemComponent,
  ApplyTagComponent
];

const DIALOGS = [
  AddOrUpdateFieldResponseDialog,
  ShiftAddOrUpdateDialog,
  CampaignsForFieldDialog,
  CampaignsForResponseDialog,
  ApplyTagWithFieldSelectDialog,
  ApplyTagDialog
];

const FORMS = [
  FieldResponseFormComponent,
  ShiftInfoFormComponent,
  ApplyTagFormComponent,
  ApplyTagMultiFormComponent
];

@NgModule({
    imports: [
        SharedModule,
        NoteModule,
        ConnectionTypesSharedModule
    ],
    declarations: [
        ...DIRECTIVES,
        ...FORMS,
        ...COMPONENTS,
        ...DIALOGS
    ],
    providers: [],
    exports: [
        ...DIRECTIVES,
        ...FORMS,
        ...COMPONENTS,
        ...DIALOGS
    ]
})
export class FieldSharedModule { }
